<template>
<div class='container'>
   <app-header
      bgcolor="#49515B"
      :transparent="true"
      :title="title"
      back-type="back-app"
    />
    <div class="member_img_box">
      <img src="https://img-cdn1.ylyk.com/image/1666259689827_m1666259682030_s378423.jpg" alt="">
      <img src="https://img-cdn1.ylyk.com/image/1666259689827_m1666259687314_s315034.jpg" alt="">
    </div>
</div>
</template>

<script>

export default {
  data() {
    return {
      title: '会员介绍'
    }
  },
  created() {
  },

  methods: {}
}
</script>

<style lang='less' scoped>
.member_img_box{
  img{
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
